export default __webpack_public_path__ + "static/media/icons-metaverses-decentraland.22147aa7.svg";